import { WISHLIST_EVENT_NAME, WISHLIST_STORAGE_KEY } from './gvode-wishlist-core.js';
import { getWishlistStore } from './gvode-wishlist-store.js';

export class GvodeWishlistHeader extends HTMLElement {
  connectedCallback() {
    this.store = getWishlistStore();
    this.render(this.store.getItems().length);
    document.addEventListener(WISHLIST_EVENT_NAME, this.onChange);
    window.addEventListener('storage', this.onStorage);
  }

  disconnectedCallback() {
    document.removeEventListener(WISHLIST_EVENT_NAME, this.onChange);
    window.removeEventListener('storage', this.onStorage);
  }

  onChange = (event) => {
    this.render(event.detail?.count);
  };

  onStorage = (event) => {
    if (event.key === WISHLIST_STORAGE_KEY || event.key === null) {
      this.render(this.store.getItems().length);
    }
  };

  render(count) {
    const bubble = this.querySelector('[data-ref="count"]');
    const link = this.querySelector('[data-ref="link"]');
    if (!bubble || !link) return;

    const safeCount = Number.isInteger(count) && count > 0 ? count : 0;
    bubble.textContent = String(safeCount);
    bubble.hidden = safeCount === 0;
    link.setAttribute('aria-label', `Wishlist, ${safeCount} saved ${safeCount === 1 ? 'item' : 'items'}`);
  }
}

if (!customElements.get('gvode-wishlist-header')) {
  customElements.define('gvode-wishlist-header', GvodeWishlistHeader);
}
